import React from "react";

const ProductAdminCreateOrderScreen = () => {
  return <div>ProductAdminCreateOrderScreen</div>;
};

export default ProductAdminCreateOrderScreen;
